import { makeAutoObservable, runInAction } from "mobx";
import { getAPIUrl } from "../../api/apiUtils";
import { apiFetch } from "../../api/apiClient";

class HistogramChartStore {
  chartData = [];
  chartLoading = false;
  chartError = null;
  interval = 1;
  startDate = '';
  endDate = '';
  selectedGroupIds = [];
  cache = {}; // Кэш для графика
  cacheAll = {}; // Кэш для всех данных (экспорт)

  constructor() {
    makeAutoObservable(this);
  }

  setFilters({ startDate, endDate, selectedGroupIds }) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.selectedGroupIds = selectedGroupIds;
  }

  setInterval(value) {
    this.interval = value;
  }

  // Ключ кэша по фильтрам
  getCacheKey(filters) {
    return JSON.stringify(filters);
  }

  async fetchChartData(sorting = [{ id: 'interval_start', desc: false }]) {
    runInAction(() => {
      this.chartLoading = true;
      this.chartError = null;
    });
    const filters = {
      startDate: this.startDate,
      endDate: this.endDate,
      selectedGroupIds: this.selectedGroupIds,
      interval: this.interval
    };
    const cacheKey = this.getCacheKey(filters);
    if (this.cache[cacheKey]) {
      this.chartData = this.cache[cacheKey];
      this.chartLoading = false;
      return;
    }
    try {
      if (!this.startDate || !this.endDate || this.selectedGroupIds.length === 0) {
        runInAction(() => {
          this.chartData = [];
          this.chartLoading = false;
        });
        return;
      }
      const startTimestamp = Math.floor(new Date(this.startDate).getTime() / 1000);
      const endTimestamp = Math.floor(new Date(this.endDate).getTime() / 1000);
      const sort = sorting[0] || { id: 'interval_start', desc: false };
      const requestParams = {
        community_id: this.selectedGroupIds.join(','),
        start_date: startTimestamp,
        end_date: endTimestamp,
        interval: this.interval,
        marker_to_run: 'trager_coef',
        max_repeats: 1,
        sort_by: sort.id,
        sort_order: sort.desc ? 'asc' : 'desc',
      };
      const url = `${getAPIUrl()}/assessment/time_series_analysis`;
      const response = await apiFetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestParams),
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const result = await response.json();
      runInAction(() => {
        this.chartData = Array.isArray(result) ? result : (result.data || []);
        this.cache[cacheKey] = this.chartData;
      });
    } catch (e) {
      runInAction(() => {
        this.chartData = [];
        this.chartError = e;
      });
    } finally {
      runInAction(() => {
        this.chartLoading = false;
      });
    }
  }

  // Получение всех данных для экспорта (без пагинации)
  async fetchAllData(filtersString) {
    const filters = filtersString ? JSON.parse(filtersString) : {};
    const cacheKey = this.getCacheKey(filters) + '_all';
    if (this.cacheAll[cacheKey]) {
      return this.cacheAll[cacheKey];
    }
    if (!filters.startDate || !filters.endDate || !filters.selectedGroupIds || filters.selectedGroupIds.length === 0) {
      return [];
    }
    const startTimestamp = Math.floor(new Date(filters.startDate).getTime() / 1000);
    const endTimestamp = Math.floor(new Date(filters.endDate).getTime() / 1000);
    const requestParams = {
      community_id: filters.selectedGroupIds.join(','),
      start_date: startTimestamp,
      end_date: endTimestamp,
      interval: filters.interval || 5,
      marker_to_run: 'trager_coef',
      max_repeats: 1,
      sort_by: 'interval_start',
      sort_order: 'asc',
    };
    const url = `${getAPIUrl()}/assessment/time_series_analysis`;
    const response = await apiFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestParams),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();
    const data = Array.isArray(result) ? result : (result.data || []);
    this.cacheAll[cacheKey] = data;
    return data;
  }
}

export const histogramChartStore = new HistogramChartStore();
